import { useQuery } from "@tanstack/react-query";

import userAPIService from "../services/api/user";
import abilityService from "../services/ability";

function getPermissions() {
  return userAPIService.getPermissions();
}

export function usePermissionsQuery() {
  return useQuery({
    queryKey: ["permissions"],
    queryFn: () => {
      return getPermissions().then((permissions) => {
        abilityService.updateAbility(permissions);
        return permissions;
      });
    },
    staleTime: Infinity,
    // Fetched only through an explicit refetch() once the user is authenticated.
    enabled: false,
  });
}
